var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5901 5.15039C11.7233 5.15039 11.8441 5.21287 11.9397 5.31738C12.0287 5.42899 12.0738 5.56745 12.0608 5.71387C12.0596 5.77741 11.7044 10.5565 11.5012 12.5703C11.3738 13.8081 10.6235 14.5595 9.49829 14.5801C8.63331 14.6007 7.78782 14.6084 6.95532 14.6084C6.07136 14.6084 5.20655 14.6007 4.36743 14.5801C3.27991 14.5524 2.52838 13.7874 2.40747 12.5703C2.19843 10.5488 1.84945 5.77482 1.84204 5.71387C1.83554 5.56751 1.88038 5.42896 1.96997 5.31738C2.05838 5.21287 2.18567 5.15039 2.31958 5.15039H11.5901ZM8.33228 0.389648C8.92307 0.389749 9.45101 0.828555 9.60376 1.4541L9.71313 1.97363C9.80172 2.39636 10.1459 2.69531 10.5422 2.69531H12.4915C12.7513 2.69556 12.967 2.92574 12.967 3.21777V3.4873C12.967 3.77224 12.7513 4.00951 12.4915 4.00977H1.41333C1.15282 4.00955 0.936768 3.77226 0.936768 3.4873V3.21777C0.936768 2.92571 1.15283 2.69552 1.41333 2.69531H3.36255C3.75841 2.69529 4.1026 2.39592 4.19165 1.97363L4.29419 1.48926C4.45276 0.828966 4.97434 0.389877 5.57153 0.389648H8.33228Z",
    fill: "#D11A2A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.1850fedb336a313be22f9547f65436c0.svg";
export { ForwardRef as ReactComponent };